export const showPaymentBlinder = () => {
    const div = document.createElement('div');

    div.id = 'payment-blinder';
    document.body.appendChild(div);
};

export const hidePaymentBlinder = () => {
    // @ts-ignore
    if (document.getElementById('payment-blinder')) {
        document.getElementById('payment-blinder')?.remove();
    }
};

export const toggleExpandClass = (elementId: string) => {
    if (document.getElementById(elementId)) {
        document.getElementById(elementId)?.classList.toggle('expanded');
    }
};
